import { styled } from "@mui/material/styles";
import { Box,
  Button,
  Card,
  Grid,
  IconButton,
  FormControlLabel,
  Paper,
  TableCell,
  TableBody,
  TableHead,
  Table,
  Switch,
  TableContainer as MuiTableContainer, 
  Chip,
  Toolbar,
  FormControl,
  Tabs} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useColors } from "../Context/ColorsContext";
import { BaseAutocomplete, BaseSelect, BaseSelectTextField, BaseTextField, MediaQuerys } from "../styles/GlobalStyle";
import { PictureAsPdf } from "@mui/icons-material";
import DownloadIcon from '@mui/icons-material/Download';

const drawerWidth = 120;
const formItemHeight = "32px";
const { mobile, tablet, desktop, desktoplarge } = MediaQuerys;

function setSize(open, isExternal, customWidth) {
  if (customWidth) return customWidth;
  if (isExternal) return "100%";
  return `calc(100vw - ${drawerWidth}px)`;
}

export const Container = styled(Box)(
  ({ theme, open, isExternal, customWidth, isModal }) => ({
    [theme.breakpoints.up("md")]: {
      width: setSize(open, isExternal, customWidth),
    },
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginTop: 8,
    marginBottom: isModal ? 8 : 50,
    flexGrow: 1,

  })
);



export const ContainerCard = styled(Card)(() => {
  const { colors } = useColors();
  return {
    backgroundColor: colors.white,
    borderRadius: 6,
    padding: 20
  }
})

export const Search = styled(SearchIcon)(() => {
  const { colors } = useColors();
  return {
    width: 20,
    height: 20,
    cursor: 'pointer',
    color: colors.grayFont
  }
})

export const GridScroll = styled(Grid)((props) => ({
  "&::-webkit-scrollbar": {
    width: 5,
  },
  "&::-webkit-scrollbar-track": {
    background: "#F3F2F2",
    borderRadius: 100,
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#CBCBCB",
    borderRadius: 100,
  },
  scrollbarWidth: "thin",
  scrollbarColor: "#CBCBCB #F3F2F2",
  marginTop: 10,
  padding: 0,
  overflow: "auto",
  height: `${props.normal ? "auto" : "595px"}`,
  [tablet]: {
    height: `${props.normal ? '876px' : (props.childVoid ? 'auto' : '460px')}`
  },
  [mobile]: {
    height: `${props.isStandard ? '300px' : (props.normal ? 'auto' : props.childVoid && 'auto')}`
  },
}));

export const EmptyContainer = styled(Grid)(({ childVoid }) => {
  const { colors } = useColors();
  return {
    display: 'flex',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    marginTop: 20,
    textAlign: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    color: colors.grayFont,
    backgroundColor: 'white',
    [tablet]: {
      // height: childVoid && 'auto'
    },
    [mobile]: {
      height: '170px',
      marginTop: 0,
    }
  }
})

export const CustomButton = styled(Button)(({ type }) => {
  const { colors } = useColors();
  return {
    background: colors.buttonActionColor,
    color: colors.white,
    marginBottom: 6,
    bottom: 0,
    right: 0,
    textTransform: 'capitalize',
    fontSize: 13,
    "&:hover": {
      backgroundColor: colors.buttonActionColor,
      opacity: 0.9,
      color: colors.white,
    }
  }
})

function buttonType(type) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { colors } = useColors();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  if (type === 'cancel') return colors.white
  // eslint-disable-next-line react-hooks/rules-of-hooks
  if (type === 'close') return colors.white
  // eslint-disable-next-line react-hooks/rules-of-hooks
  if (type === 'delete') return colors.red
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return colors.buttonActionColor
}
//?? FORM BUTTON
export const FormButton = styled(Button)(({ type, btnCancel, isUpdateStatus }) => {
  const { colors } = useColors();
  return {
    display: btnCancel === false || isUpdateStatus ? 'none' : null,
    background: buttonType(type),
    height: 28,
    padding: '0 35px',
    color: `${type !== 'cancel' && type !== 'close' ? colors.white : colors.buttonActionColor}`,
    borderColor: colors.buttonActionColor,
    "&:hover": {
      background: buttonType(type),
      borderColor: colors.buttonActionColor,
      opacity: 0.8
    },
    [desktop]: {
      height: '25px',
      fontSize: '0.85rem',
    },
    borderRadius: 8,
    "& .MuiButtonBase-root": {
      borderRadius: 8,
    }
  }
})

export const CustomIconButton = styled(IconButton)(({ iconColor }) => {
  const { colors } = useColors();
  return {
    borderRadius: '10%',
    backgroundColor: colors.background,
    color: iconColor ? colors[iconColor] : colors.buttonActionColor,
    "&:hover": {
      backgroundColor: iconColor ? colors.background : colors.buttonActionColor,
      opacity: 0.9,
      color: colors.background,
    }
  }
})

export const SearchButton = styled(Button)(({ ButtonModal, headerTable, isStandard, management, isMobile }) => {
  const { colors } = useColors();
  return {
    height: 28,
    padding: '0 35px',
    color: colors.white,
    backgroundColor: colors.buttonActionColor,
    "&:hover": {
      backgroundColor: colors.buttonActionColor,
      opacity: 0.9,
      color: colors.white,
    },
    [desktop]: {
      display: isMobile && 'none',
      width: management && "140px",
      fontSize: isStandard ? '0.80rem' : "0.60rem",
      padding: '0 20px',
    },
    [tablet]: {
      height: isStandard ? '28px' : '20px',
      fontSize: ButtonModal ? '0.875rem' : (isStandard ? '0.80rem' : '8px'),
    },
    [mobile]: {
      display: isStandard || headerTable,
      height: isStandard && '25px',
    },
  }
})

export const ClearIconButton = styled(IconButton)(({ isFirstClearButton }) => {
  const { colors } = useColors();
  return {
    display: isFirstClearButton ? "none" : "",
    borderRadius: 20,
    pointerEvents: 'pointer',
    background: colors.buttonActionColor,
    color: colors.white,
    marginLeft: 5,
    "&:hover": {
      backgroundColor: colors.buttonActionColor,
      opacity: 0.9,
      color: colors.white,
    },
    [desktop]: {
      display: "inline-flex",
      fontSize: "0.25rem",
      height: 25,
      width: 25,
    },
  }
})

export const BoxModal = styled(Box)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
}));

export const BoxRiskModal = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '2rem',

  backgroundColor: "#fff",
  borderRadius: "8px",

  width: "90vw",
  maxWidth: "1600px",

  height: "auto",
  overflowY: "auto",

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const ContainerRiskModal = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "1rem",
}))

export const RiskImg = styled("img")(({ theme }) => ({
  width: "96%",
  height: "auto",
  objectFit: "contain",
  maxHeight: "90vh",
  borderRadius: "8px",

  [theme.breakpoints.down('md')]: {
    width: "100%",
    height: "50%",
  },
}))

export const LanguageContainer = styled("div")(({ insideApp = true }) => ({
  display: "flex",
  justifyContent: "flex-end",
  width: insideApp ? "100%" : undefined,
  padding: "6px 6px 0 0",
}));

export const IconCustomContainer = styled("div")(() => {
  const { colors } = useColors();
  return {
    // width: "100%",
    display: "flex",
    // justifyContent: "right",
    // textAlign: "flex-end",
    alignItems: "center",
    // padding: "0 6px 0 0",
    gap: "12px",

    background: colors.navbarColor,
    padding: "6px 12px",

    width: "fit-content",
    marginLeft: "auto",

    "& img": {
      width: 110,
      height: "auto",
      objectFit: "contain"
    },

    [mobile]: {
      width: "100%",
      justifyContent: "center",
      borderRadius: 0
    }
  }
});


//TODO: CONTENEDORES BAR SEARCH GLOBALES 

export const ContainerBarSearch = styled("div")(({theme}) => ({
  width: 650,
  height: 35,
  fontSize: "14px",
  [desktop]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "500px",
  },
  [tablet]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "420px",
  },
  [mobile]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "420px",
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: "12px",
    width: "100%",
  },
}));

export const ContainerCertificateBarSearch = styled("div")(() => ({
  width: 650,
  height: 40,
  [desktop]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "",
    "& input": {
      fontSize: "0.75rem",
    }
  },
  [tablet]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "420px",
    height: "25px",
    "& input": {
      fontSize: "0.65rem",
    },
  },
}));

export const ContainersButtonsGroup = styled('div')(({ twoContainers }) => ({
  display: "flex",
  flexDirection: 'row',
  gap: '0.7rem',
  alignItems: 'center',
  paddingBottom: '1rem',
  [desktop]: {
    marginTop: '0'
  },
  [mobile]: {
    justifyContent: twoContainers ? 'space-between' : 'flex-end',
    flexDirection: twoContainers && 'row-reverse',
  }
}))

export const ContainerButtonDownload = styled("div")(({ widthBtn, height, flexDirection }) => ({
  flexDirection: flexDirection,
  width: widthBtn || 140,
  height: height || 35,
  [desktop]: {
    width: "auto",
    height: formItemHeight,
    "& button": {
      fontSize: "0.75rem",
    },
  },
  [tablet]: {
    width: "100px",
    height: 28,
    "& button": {
      fontSize: "8px",
    },
  },
}));

export const ContainerButtonDownloadWeeklyReport = styled("div")(({ widthBtn, height, flexDirection }) => ({
  flexDirection: flexDirection,
  width: widthBtn || 160,
  height: height || 40,
  [desktop]: {
    width: "210px",
    height: "30px",
    "& button": {
      fontSize: "0.65rem",
    },
  },
  [tablet]: {
    width: "100px",
    height: 28,
    "& button": {
      fontSize: "8px",
    },
  },
}));

export const SectionPageTitle = styled("section")(() => ({
  display: "flex",
  height: "auto",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: '10px',
  [desktoplarge]: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "space-between",
  },
  [mobile]: {
    flexDirection: "column",
    gap: '10px'
  }
}));

export const SectionCertificatePageTitle = styled("section")(() => ({
  display: "flex",
  height: "100%",
  width: "100%",
  [desktoplarge]: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
  },
  [mobile]: {
    flexDirection: "column",
    gap: '10px'
  }
}));

export const SectionPageLeft = styled("div")(() => ({
  height: "auto",
  width: "auto",
  display: "flex",
  flexDirection: "row",
  gap: "1rem",
  alignItems: "center",
  [mobile]: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
}));

/* export const SectionCertificatePageLeft = styled("div")(() => ({
  height: "auto",
  width: "auto",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems:"center",
  gap: "1rem",
  [mobile]: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
})); */

export const Forms = styled('form')(({ isManagement }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  justifyContent: isManagement ? 'space-between' : 'flex-end',
  [tablet]: {
    justifyContent: isManagement ? 'space-between' : 'flex-end',
  },
  [mobile]: {
    height: 'auto',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
  [desktop]: {
    alignItems: 'center',
  }
}))


export const ContainerGroupBar = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row'
}))


export const IconsButtonsTable = styled(IconButton)(({ needMargin }) => {
  const { colors } = useColors();
  return {
    borderRadius: "10%",
    margin: needMargin ? "0 .5px" : 0,
    backgroundColor: colors.background,
    color: colors.buttonActionColor,
    "&:hover": {
      backgroundColor: colors.buttonActionColor,
      color: colors.white,
    },
  }
})

export const PdfIconButton = styled(PictureAsPdf)(() => {
  const { colors } = useColors();
  return {
    cursor: 'pointer',
    fontSize: 30,
    color: colors.red,
    "&:hover": {
      opacity: 0.9,
    }
  }
})

export const CustomFormControlLabel = styled(FormControlLabel)(() => {
  return {
    [desktop]: {
      '.MuiTypography-root': {
        fontSize: '0.85rem'
      }
    }
  }
})

export const PdfDownloadIcon = styled(DownloadIcon)(() => {
  const { colors } = useColors();
  return {
    fontSize: 50,
    color: colors.buttonActionColor,
    padding: '.5rem',
    backgroundColor: colors.background,
    borderRadius: "10%",
    margin: '0 .5rem',
    "&:hover": {
      backgroundColor: colors.buttonActionColor,
      opacity: 0.9,
      color: colors.background,
      cursor: 'pointer'
    }
  }
})

export const CustomButtonV2 = styled(Button)(({ theme, btnType }) => {
  const { colors } = useColors();

  const getButtonStyles = (type) => {
    switch (type) {
      case 'delete':
        return {
          backgroundColor: '#e9e9ea',
          color: '#ef3a3a',
          border: 'none',
          hoverBackgroundColor: '#e9e9ea',
          hoverColor: '#ef3a3a',
          hoverBorder: 'none'
        };
      case 'primary':
        return {
          backgroundColor: colors.buttonActionColor,
          color: colors.white,
          border: `1px solid ${colors.buttonActionColor}`,
          hoverBackgroundColor: colors.buttonActionColor,
          hoverColor: colors.white,
          hoverBorder: `1px solid ${colors.buttonActionColor}`
        };
      case 'secondary':
        return {
          backgroundColor: '#f3f4f6',
          color: colors.buttonActionColor,
          border: `1px solid #d5d8de`,
          hoverBackgroundColor: '#f3f4f6',
          hoverColor: colors.buttonActionColor,
          hoverBorder: `1px solid #d5d8de`
        };
      case 'cancel':
        return {
          backgroundColor: 'transparent',
          color: '#585858',
          border: `1px solid #ececec`,
          hoverBackgroundColor: 'transparent',
          hoverColor: '#585858',
          hoverBorder: `1px solid #ececec`
        };
      case 'close':
        return {
          backgroundColor: 'transparent',
          color: colors.buttonActionColor,
          border: `1px solid ${colors.buttonActionColor}`,
          hoverBackgroundColor: 'transparent',
          hoverColor: colors.buttonActionColor,
          hoverBorder: `1px solid ${colors.buttonActionColor}`,
          hoverOpacity: 0.8
        };
      case "gray":
        return {
          backgroundColor: '#e9e9ea',
          color: colors.sidebarSelectColor,
          border: 'none',
          hoverBackgroundColor: '#e9e9ea',
          hoverColor: colors.sidebarSelectColor,
          hoverBorder: 'none',
          hoverOpacity: 0.8
        };
      case 'clean':
        return {
          backgroundColor: colors.white,
          color: colors.buttonActionColor,
          border: `1px solid #E0E0E0`,
          hoverBackgroundColor: colors.white,
          hoverColor: colors.buttonActionColor,
          hoverBorder: `1px solid #E0E0E0`,
          hoverBoxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)"
        };
      default:
        return {
          backgroundColor: colors.sidebarSelectColor,
          color: colors.white,
          border: `1px solid ${colors.sidebarSelectColor}`,
          hoverBackgroundColor: colors.sidebarSelectColor,
          hoverColor: colors.white,
          hoverBorder: `1px solid ${colors.sidebarSelectColor}`
        };
    }
  };

  const styleProps = getButtonStyles(btnType);

  return {
    height: formItemHeight,
    width: "100%",
    padding: "0 10px",
    textTransform: "none",
    lineHeight: 1,
    backgroundColor: styleProps.backgroundColor,
    color: styleProps.color,
    border: styleProps.border,
    boxShadow: "none",
    borderRadius: 8,
    fontSize: "14px !important",
    "&:hover": {
      backgroundColor: styleProps.hoverBackgroundColor,
      opacity: styleProps.hoverOpacity || 0.9,
      color: styleProps.hoverColor,
      border: styleProps.hoverBorder,
      boxShadow: styleProps.hoverBoxShadow || "none",
    },
    ...(btnType === 'clean' && {
      "& .MuiSvgIcon-root": {
        color: colors.buttonActionColor,
      },
      "& .text": {
        color: colors.grayDemo,
      }
    }),
    "&:disabled": {
      backgroundColor: '#f8f8f8',
      color: '#dee2e6',
      border: '1px solid #dee2e6',
    },
    "& .MuiButton-icon.MuiButton-startIcon": {
      marginRight: 2,
    },
    "& .MuiButton-icon.MuiButton-endIcon": {
      marginLeft: 2,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: "12px !important",
    },
  };
});

export const CustomSelectDemo = styled(BaseSelect)(() => {
  return {}
});

export const PageTitle = styled('p')(() => {
  const { colors } = useColors();
  return {
    color: colors.titleTextColor,
    alignContent: "center",
    textAlign: "left",
    fontWeight: "700",
    fontSize: '24px !important',
    [mobile]: {
      fontSize: '18px !important',
    },
  };
});

// Estilos para componente tabla
export const CustomToolbar = styled(Toolbar)(({theme}) => {
  const { colors } = useColors();
  return {
    background: colors.white,
    borderRadius: '10px',
    border: '1px solid #e0e0e0',
    minHeight: "40px !important",
    padding: "5px 10px !important",
    [theme.breakpoints.down('md')]: {
      background: 'transparent',
      border: 'none',
      padding: "0px !important",
    },
  };
});

export const TableContainer = styled(Paper)(() => {
  return {
    width: "100%",
    marginTop: "1.3rem",
    borderRadius: "10px",
    "& .MuiTablePagination-root .MuiToolbar-root.MuiTablePagination-toolbar": {
      minHeight: "30px"
    },
  }
});

export const TableHeight = styled(MuiTableContainer)(({theme, isManagement}) => {
  return {
    height: isManagement ? 'calc(100vh - 350px)' : 'calc(100vh - 290px)', // Mobile (< md) (3 lines or 4)
    borderRadius: "8px",
    [theme.breakpoints.up('sm')]: {
      height: isManagement ? 'calc(100vh - 300px)' : 'calc(100vh - 270px)' // Tablet (md to < lg) (2 lines  or 3)
    },
    [theme.breakpoints.up('md')]: {
      height: isManagement ? 'calc(100vh - 270px)' : 'calc(100vh - 250px)' // Tablet (md to < lg) (2 lines or 3)
    },
    [theme.breakpoints.up('lg')]: {
      height: isManagement ? 'calc(100vh - 260px)' : 'calc(100vh - 210px)' // Desktop (lg+) (1 line or 2)
    },
  }
});

export const CustomTableHead = styled(TableHead)(() => {
  const { colors } = useColors();
  return {
    "& .MuiTableRow-head": {
      borderRadius: "8px",
    },
    "& .MuiTableRow-head .MuiTableCell-root span": {
      fontSize: "14px",
      lineHeight: 1.2,
      color: colors.navbarColor,
      [tablet]: {
        fontSize: "12px",
      }
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      paddingTop: "8px !important",
      paddingBottom: "8px !important",
      background: "#eeeeee"
    },
  };
});

export const HeaderCell = styled(TableCell)(({ dataHead, theme }) => {
  const { colors } = useColors();
  let sticky = dataHead?.sticky;
  let direction = dataHead?.direction;

  return {
    position: sticky && 'sticky',
    [direction]: sticky && 0,
    background: sticky && colors.white,
    zIndex: sticky && '9',
    borderTop: "none",
    borderBottom: "none",
	boxShadow: sticky ? (direction === "left" ? "2px 0px 2px 0px rgba(0, 0, 0, 0.05)" : "-2px 0px 2px 0px rgba(0, 0, 0, 0.05)") : "none",
    fontSize: "14px",
    fontWeight: 600,
    paddingTop: "10px !important",
    paddingBottom: "10px !important",
    alignItems: "center",
    padding: "0 16px",
    color: colors.buttonActionColor,
    '& .MuiButtonBase-root': {
      position: 'unset',
    },
    "&:hover": {
      color: colors.buttonActionColor,
      opacity: 0.9
    },
    [tablet]: {
      fontSize: "12px !important",
    },
    [theme.breakpoints.down('sm')]: {
      position: 'static !important',
      borderRight: 'none',
      borderLeft: 'none',
      zIndex: 'auto',
    }
  }
});

export const CustomTable = styled(Table)(() => {
  return {
    "& .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root": {
      padding: "6px 10px",
    },
    tableLayout: "auto",
    width: "100%"
  };
});

export const TableContent = styled(TableBody)(() => {
  return {
    ".MuiTableCell-root": {
      fontSize: "14px !important",
      [tablet]: {
        fontSize: "12px !important",
      },
    },
    [tablet]: {
      ".MuiTablePagination-displayedRows": {
        fontSize: "12px !important",
      },
      ".MuiTablePagination-selectLabel": {
        fontSize: "12px !important",
      },
    },
    '& tr td:first-child': {
      color: '#16355c',
      fontWeight: 'bold',
    }
  }
});

export const Cell = styled(TableCell)(({ direction, theme }) => {
  const { colors } = useColors();
  const sticky = !!direction;

  return {
    position: sticky && 'sticky',
    background: sticky && colors.white,
    [direction]: sticky && 0,
    border: "none",
    width: "max-content",
    maxWidth: "16rem",
    whiteSpace: "normal",
    wordBreak: "break-word",
    borderTop: '1px solid #E0E0E0 !important',
    borderBottom: "none",
	  boxShadow: direction === "left" ? "2px 0px 2px 0px rgba(0, 0, 0, 0.05)" : (direction === "right" ? "-2px 0px 2px 0px rgba(0, 0, 0, 0.05)" : "none"),
    [theme.breakpoints.down('sm')]: {
      position: 'static !important',
      borderRight: 'none',
      borderLeft: 'none',
    }
  }
});

export const CustomIconButtonDemo = styled(IconButton)(({ btnType, theme }) => {
  const { colors } = useColors();
 
  const getStyleProps = (type) => {
    switch (type) {
      case 'delete':
        return {
          backgroundColor: '#e9e9ea',
          color: '#ef3a3a',
          hoverBackgroundColor: '#e9e9ea',
          hoverColor: '#ef3a3a'
        };
      case 'primary':
        return {
          backgroundColor: colors.buttonActionColor,
          color: colors.white,
          hoverBackgroundColor: colors.buttonActionColor,
          hoverColor: colors.white
        };
      case 'secondary':
        return {
          backgroundColor: '#f3f4f6',
          color: colors.buttonActionColor,
          border: `1px solid #d5d8de`,
          hoverBackgroundColor: '#f3f4f6',
          hoverColor: colors.buttonActionColor
        };
      case 'graySidebar':
        return {
          backgroundColor: colors.background,
          color: colors.sidebarSelectColor,
          hoverBackgroundColor: colors.sidebarSelectColor,
          hoverColor: colors.background
        };
      default:
        return {
          backgroundColor: colors.background,
          color: colors.buttonActionColor,
          hoverBackgroundColor: colors.buttonActionColor,
          hoverColor: colors.background
        };
    }
  };

  const styleProps = getStyleProps(btnType);

  return {
    height: formItemHeight,
    width: formItemHeight,
    borderRadius: "8px",
    backgroundColor: styleProps.backgroundColor,
    color: styleProps.color,
    border: styleProps.border,
    "&:hover": {
      backgroundColor: styleProps.hoverBackgroundColor,
      opacity: 0.9,
      color: styleProps.hoverColor,
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1.1rem',
    },
    [theme.breakpoints.up('xl')]: {
      '& .MuiSvgIcon-root': {
        fontSize: '1.2rem',
      },
    },
  };
});

export const CustomChipStatus = styled(Chip)(({ enabled }) => {
  return {
    backgroundColor: enabled ? "#c7f6d6" : "#ffe4e5",
    color: enabled ? "#147342" : "#ef4444",
    fontWeight: 600,
    fontSize: '11px',
    height: 'auto',
    minHeight: '22px',
    borderRadius: '16px',
    padding: '2px 2px',
    "& .MuiChip-label": {
      padding: "2px 8px",
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
    "& .MuiChip-icon": {
      color: "inherit",
      marginLeft: "6px",
      marginRight: "-4px",
      fontSize: "14px",
    }
  }
});

// Estilos para formularios
export const CustomFormLabel = styled('div')(({theme, bold}) => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '2px',
    fontSize: '14px',
    fontWeight: bold ? 'bold' : 'normal',
    '& .material-symbols-outlined': {
      fontSize: '16px',
      color: '#aeb4bd',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '12px'
    },
  }
})

export const CustomFormControl = styled(FormControl)(() => ({
    '& .Mui-disabled': {
        backgroundColor: '#FAFAFA'
    }
}));

export const CustomTextField = styled(BaseTextField)(({ fullWidth }) => {
  return {
    width: fullWidth ? '100%' : 'auto',
  }
});

export const CustomTextArea = styled("textarea")(({ theme }) => ({
  width: "100%",
  padding: "12px",
  borderRadius: '8px',
  border: "1px solid #dbdcdcff",  
  outline: "none",
  resize: "vertical",
  fontSize: 14,
  "&:focus": {
    border: "1px solid #c0c1c3ff", 
  },
  '&:disabled': {
    color: '#a3a3a3 !important',
    WebkitTextFillColor: '#a3a3a3 !important',
    backgroundColor: '#fbfcfd !important',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: 12,
  }
}));

export const ContainerInputsDate = styled("div")(() => {
  const { colors } = useColors();
  return {
    '& .MuiOutlinedInput-root': {
      background: colors.white,
      borderRadius: '8px',
      fontSize: '14px',
      height: formItemHeight,
      '& fieldset': {
        borderColor: colors.grayDemo 
      }
    },
    '& .MuiFormLabel-root': {
      fontSize: "14px",
      color: colors.grayDemo,
      lineHeight: 1,
      [tablet]: {
        fontSize: "12px"
      }
    },
    '& .MuiInputBase-root': {
      fontSize: "14px",
      overflow: "hidden",
      paddingTop: '0px',
      [tablet]: {
        fontSize: "12px",
      },
    },
    '& .MuiStack-root': {
      paddingTop: '0px !important',
      overflow: 'visible !important',
    },
    '& .MuiStack-root > .MuiTextField-root': {
      minWidth: '100%',
      width: '100%',
    },
  }
});

export const CustomSelect = styled(BaseAutocomplete)(() => {
  return {}
})

export const CustomSelectInput = styled(BaseSelectTextField)(() => {
  return {}
})

export const AntSwitch = styled(Switch, {
  shouldForwardProp: (prop) => prop !== 'activeColor',
})(({ theme, activeColor }) => {
  const { colors } = useColors();
  const trackColor = activeColor === 'secondary' ? colors.sidebarSelectColor : colors.buttonActionColor;
  return {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: trackColor,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
  };
});

export const AntSwitchBorderedControlLabel = styled(FormControlLabel)(() => {
  return {
    border: '1px solid #dbdcdcff',
    borderRadius: '8px',
    backgroundColor: '#fff',
    margin: 0,
    width: '100%',
    height: formItemHeight,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiFormControlLabel-label': {
      fontSize: '11px !important',
      color: '#7b7c7b',
      textAlign: 'center',
      marginLeft: '8px',
    }
  }
});

export const AntSwitchControlLabel = styled(FormControlLabel)(({ theme }) => {
  return {
    margin: 0,
    width: '100%',
    height: formItemHeight,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& .MuiFormControlLabel-label': {
      fontSize: '14px !important',
      color: '#7b7c7b',
      marginLeft: '8px',
      [theme.breakpoints.down('md')]: {
        fontSize: '12px !important',
      }
    }
  }
});

// Estilos para ventanas modales
export const ModalHeader = styled('div')(({ theme }) => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    color: colors.sidebarSelectColor,
    width: '100%',
    height: 'fit-content',
    borderRadius:'10px 10px 0 0',
    padding:'10px 16px 0px 16px',
    textTransform:'uppercase',
    fontWeight:600,
    fontSize: '16px',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
    }
  }
})

export const ModalSubHeader = styled('span')(() => {
  return {
    color: '#a6a6a6',
    fontSize: '11px',
    padding: '0 16px 8px 16px',
    margin: 0,
    background: '#fff',
    borderBottom: '1px solid #dbdbdbff',
  }
})

export const ModalFooter = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    width: '100%',
    height: 'fit-content',
    borderRadius:'0 0 10px 10px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '10px 16px',
    margin: 'auto',
    borderTop: '1px solid #dbdbdbff',
  }
})

// Estilos para tabs
export const CustomTabs = styled(Tabs)(() => {
  // eslint-disable-next-line no-use-before-define
  const { colors } = useColors();
  return {
    backgroundColor: '#fff',
    borderRadius: '10px',
    border: '1px solid #e0e0e0',
    padding: '4px',
    minHeight: 'auto',
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .MuiButtonBase-root.MuiTab-root': {
      textTransform: 'none',
      margin: '0 4px',
      minHeight: '30px',
      zIndex: 1,
      opacity: 1, 
      color: '#68798f',
      padding: '5px 13px 5px 2px !important',
      fontWeight: 500,
      whiteSpace: 'nowrap',
    },
    // Agregar borde separador entre tabs
    '& .MuiTabs-flexContainer > div + div': {
      borderLeft: '1px solid #efefef',
    },
    '& .MuiTabs-flexContainer': {
      gap: '8px',
    },
    // Agregar color de fondo a tab seleccionada
    '& .MuiTabs-flexContainer > div[data-selected="true"] > div': {
      backgroundColor: colors.sidebarSelectColor,
    },
    // Modificar estilos de textos de tab selecionada
    '& .MuiTabs-flexContainer > div[data-selected="true"] .MuiTab-root': {
      color: '#fff !important',
    },
    '& .MuiTabs-flexContainer > div[data-selected="true"] .MuiBadge-badge': {
      backgroundColor: colors.navbarColor,
      border: `1px solid ${colors.navbarColor}`,
      color: '#fff',
    },
    '& .MuiButtonBase-root': {
      fontSize: '14px'
    },
    [tablet]: {
      '& .MuiButtonBase-root': {
        fontSize: '12px'
      },
    },   
  }
});

